module.exports = __webpack_public_path__ + "static/media/10S.3963b09b.svg";